module.exports = __webpack_public_path__ + "static/media/Fabio-174.cb37bb30.jpg";